<template>
  <div class="tools">
    <template v-if="view == 'DEFAULT' || view == 'SEARCH'">
      <div class="p20 d-flex justify-content-between align-items-center">
        <h2 class="title" h30 v-if="view == 'DEFAULT'">Add Resources</h2>
        <input
          type="search"
          autofocus="autofocus"
          v-model="searchStr"
          v-if="view == 'SEARCH'"
          class="form-control h30 search"
        />
        <div class="icos">
          <div class="ico" @click="view = 'SEARCH'" v-if="view == 'DEFAULT'">
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M11 4C7.13401 4 4 7.13401 4 11C4 14.866 7.13401 18 11 18C14.866 18 18 14.866 18 11C18 7.13401 14.866 4 11 4ZM2 11C2 6.02944 6.02944 2 11 2C15.9706 2 20 6.02944 20 11C20 15.9706 15.9706 20 11 20C6.02944 20 2 15.9706 2 11Z"
                fill="#474D52"
              />
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M15.9428 15.9429C16.3333 15.5524 16.9665 15.5524 17.357 15.9429L21.707 20.2929C22.0975 20.6834 22.0975 21.3166 21.707 21.7071C21.3165 22.0976 20.6833 22.0976 20.2928 21.7071L15.9428 17.3571C15.5523 16.9666 15.5523 16.3334 15.9428 15.9429Z"
                fill="#474D52"
              />
            </svg>
          </div>
          <div
            class="ico ico-close"
            @click="$emit('close-dashcard')"
            v-if="view === 'DEFAULT'"
          >
            <svg
              width="32"
              height="32"
              viewBox="0 0 32 32"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <circle cx="16" cy="16" r="16" fill="#E4E6EB" />
              <g clip-path="url(#clip0)">
                <path
                  d="M16.7855 16.0008L22.9482 9.83807C23.1652 9.6211 23.1652 9.26932 22.9482 9.05238C22.7312 8.83543 22.3794 8.83541 22.1625 9.05238L15.9998 15.2151L9.83709 9.05238C9.62012 8.83541 9.26834 8.83541 9.0514 9.05238C8.83446 9.26935 8.83443 9.62113 9.0514 9.83807L15.2141 16.0008L9.0514 22.1635C8.83443 22.3804 8.83443 22.7322 9.0514 22.9492C9.15987 23.0576 9.30207 23.1119 9.44426 23.1119C9.58646 23.1119 9.72862 23.0576 9.83712 22.9492L15.9998 16.7865L22.1625 22.9492C22.2709 23.0576 22.4131 23.1119 22.5553 23.1119C22.6975 23.1119 22.8397 23.0576 22.9482 22.9492C23.1652 22.7322 23.1652 22.3804 22.9482 22.1635L16.7855 16.0008Z"
                  fill="#606770"
                />
              </g>
              <defs>
                <clipPath id="clip0">
                  <rect
                    width="14.2222"
                    height="14.2222"
                    fill="white"
                    transform="translate(8.88867 8.88889)"
                  />
                </clipPath>
              </defs>
            </svg>
          </div>
          <div class="ico" @click="view = 'DEFAULT'" v-if="view == 'SEARCH'">
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M19 6.41L17.59 5L12 10.59L6.41 5L5 6.41L10.59 12L5 17.59L6.41 19L12 13.41L17.59 19L19 17.59L13.41 12L19 6.41Z"
                fill="#474D52"
              />
            </svg>
          </div>
        </div>
      </div>

      <!-- START FILTER BY CATEGORIES -->
      <div class="filter-sec" v-if="view == 'DEFAULT'">
        <p>
          Filter by Categories
        </p>
        <div class="filters">
          <span
            class="filter"
            @click="toogleActive('finance')"
            :class="{ active: actives.includes('finance') }"
            >Finance</span
          >
          <span
            class="filter"
            @click="toogleActive('health')"
            :class="{ active: actives.includes('health') }"
            >Health</span
          >
          <span
            class="filter"
            @click="toogleActive('spiritual')"
            :class="{ active: actives.includes('spiritual') }"
            >Spiritual</span
          >
          <span
            class="filter"
            @click="toogleActive('education')"
            :class="{ active: actives.includes('education') }"
            >Education</span
          >
        </div>
      </div>
      <!-- END FILTER BY CATEGORIES -->
      <!-- START TOOLS LIST -->
      <div class="tools-list">
        <div
          class="tool"
          v-for="tool in filteredTools"
          :key="tool.toolId"
          :class="{ active: activeTools.indexOf(tool.name.toLowerCase()) > -1 }"
        >
          <span class="ico" @click="toogleToolInstant(tool)">
            <svg
              v-b-tooltip.hover
              title="Add tool"
              v-if="activeTools.indexOf(tool.name.toLowerCase()) < 0"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <circle
                cx="12"
                cy="12"
                r="12"
                fill="var(--theme-color)"
                fill-opacity="0.1"
              />
              <path
                d="M12 5.14273V18.857"
                stroke="var(--theme-color)"
                stroke-width="2"
                stroke-linecap="round"
              />
              <path
                d="M5.14258 12.0001L18.8569 12.0001"
                stroke="var(--theme-color)"
                stroke-width="2"
                stroke-linecap="round"
              />
            </svg>

            <svg
              v-else
              v-b-tooltip.hover
              title="remove tool"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <circle
                cx="12"
                cy="12"
                r="12"
                fill="var(--theme-color)"
                fill-opacity="0.1"
              />
              <path
                d="M4 13.875L8.09091 18L19 7"
                stroke="var(--theme-color)"
                stroke-width="2"
                stroke-linecap="round"
              />
            </svg>
          </span>
          <div class="content__tool" @click="ViewTool(tool)">
            <div class="info">
              <img :src="tool.imgURL" alt="" />
              <h4>{{ tool.name }}</h4>
            </div>
            <div class="desc">
              {{ tool.description ? tool.description.substr(0, 40) : "" }}
            </div>
          </div>
        </div>

        <div class="footer">
          <button @click="closeAddTools" class="btn btn-green btn-sm collapsed">
            Done
          </button>
        </div>
      </div>
      <!-- END TOOLS LIST -->
    </template>
    <template v-if="view == 'SINGLE'">
      <div class="single">
        <div class="header">
          <!-- <div class="title"> -->
          <span class="ico">
            <svg
              @click="view = 'DEFAULT'"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M12.7071 5.70711C13.0976 5.31658 13.0976 4.68342 12.7071 4.29289C12.3166 3.90237 11.6834 3.90237 11.2929 4.29289L4.29289 11.2929C3.90237 11.6834 3.90237 12.3166 4.29289 12.7071L11.2929 19.7071C11.6834 20.0976 12.3166 20.0976 12.7071 19.7071C13.0976 19.3166 13.0976 18.6834 12.7071 18.2929L7.41421 13H19C19.5523 13 20 12.5523 20 12C20 11.4477 19.5523 11 19 11H7.41421L12.7071 5.70711Z"
                fill="#474D52"
              />
            </svg>
          </span>
          <h2 class="title">Details</h2>
          <span class="ico">
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M19 6.41L17.59 5L12 10.59L6.41 5L5 6.41L10.59 12L5 17.59L6.41 19L12 13.41L17.59 19L19 17.59L13.41 12L19 6.41Z"
                fill="#474D52"
              />
            </svg>
          </span>
          <!-- </div> -->
        </div>
        <div class="d-flex align-items-center flex-column">
          <img :src="displayTool.imgURL" alt="" />
          <h2 class="headline">
            {{ displayTool.name }}
          </h2>
          <button
            class="btn btn-primary btn-sm collapsed"
            @click="toogleToolInstant(displayTool)"
          >
            {{
              activeTools.indexOf(displayTool.name.toLowerCase()) < 0
                ? "+ Add This"
                : "Remove This"
            }}
          </button>
        </div>
        <p class="desc">
          {{ displayTool.description }}
        </p>
      </div>
    </template>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  props: ["currentTools", "focus"],
  data() {
    return {
      searchStr: "",
      view: "DEFAULT",
      displayTool: {},
      /**
       * DEFAULT
       * SINGLE
       * SEARCH
       */
      actives: [],
      activeTools: [],
      tools: [],
      newTools: []
    };
  },
  mounted() {
    this.currentActiveTools(this.currentTools);
  },
  methods: {
    closeAddTools() {
      this.$emit("closeAddTools", this.currentTools);
    },
    currentActiveTools(currentTools) {
      currentTools.forEach(el => {
        this.activeTools.push(el.text.toLowerCase());
      });
    },
    toogleActive(filter) {
      let index = this.actives.indexOf(filter.toLowerCase());
      if (index > -1) {
        this.actives.splice(index, 1);
      } else {
        this.actives.push(filter.toLowerCase());
      }
    },
    toogleToolInstant(tool) {
      let index = this.activeTools.indexOf(tool.name.toLowerCase());
      console.log("tools", this.tools);
      if (index > -1) {
        this.tools.forEach(el => {
          if (tool.name == el.text) {
            this.tools.splice(el, 1);
          }
        });
        this.currentTools.forEach(el => {
          if (tool.name == el.text) {
            this.currentTools.splice(this.currentTools.indexOf(el), 1);
          }
        });
        console.log("currentTools", this.currentTools);
        this.activeTools.splice(index, 1);
      } else {
        this.addTools(tool);
        this.activeTools.push(tool.name.toLowerCase());
      }
      console.log(this.view == "SINGLE");
      if (this.view == "SINGLE") {
        this.view = "DEFAULT";
      }
    },
    ViewTool(tool) {
      this.displayTool = tool;
      this.view = "SINGLE";
    },
    addTools(tool) {
      let uid = this.checkIsToolOnDb(tool.name);
      let toolName = tool.name.split(",");
      let { _created_at, description, imgURL, name, toolId, toolRef } = tool;
      let tooldetail = {};
      if (_created_at) tooldetail._created_at = _created_at;
      if (description) tooldetail.description = description;
      if (imgURL) tooldetail.imgURL = imgURL;
      if (name) tooldetail.name = name;
      if (toolId) tooldetail.toolId = toolId;
      if (toolRef) tooldetail.toolRef = toolRef.path;
      let toolObject = {
        _created_at: new Date(),
        text: toolName[0],
        subText: toolName.length > 1 ? toolName[1] : "",
        uid: uid > -1 ? uid : undefined,
        tooldetail: tooldetail
      };
      this.tools.push(toolObject);
      console.log("toolsToUppdate", this.toolsToUpdate());
    },
    checkIsToolOnDb(name) {
      let existingTools = this.$store.getters["user/listTools"].map(
        el => el.text
      );
      if (existingTools.includes(name)) {
        return this.$store.getters["user/listTools"][
          existingTools.indexOf(name)
        ].uid;
      } else {
        return false;
      }
    },
    toolsToUpdate() {
      let refinedTools = this.tools.map(el => ({
        _created_at: el._created_at,
        uid: el.uid,
        text: el.text,
        subText: el.subText,
        tooldetail: el.tooldetail
      }));
      let toolsToSaveWOtext = [...refinedTools];
      console.log("toolsToSaveWOtext", toolsToSaveWOtext);
      delete toolsToSaveWOtext.text;
      delete toolsToSaveWOtext.subText;
      this.$store
        .dispatch("user/addTools", {
          tools: toolsToSaveWOtext.length > 0 ? toolsToSaveWOtext : []
        })
        .then(toolswUid => {
          toolswUid.map((el, index) => {
            el.tools_id = el.uid;
            el.order = index;
            el.uid = el.text.toLowerCase().replace(" ", "") + el.uid;
            el.text = refinedTools[index].text;
            el.subText = refinedTools[index].subText;
            el.imgURL = el.tooldetail.imgURL;
            delete el.tooldetail;
            return el;
          });
          this.newTools = toolswUid;
          let lastTool = [];
          if (this.currentTools.length > 0) {
            let lastOrder = this.currentTools[this.currentTools.length - 1]
              .order;
            lastTool.push(toolswUid[toolswUid.length - 1]);
            lastTool.forEach(el => {
              el.order = lastOrder + 1;
              this.currentTools.push(el);
            });
          } else {
            this.currentTools.push(toolswUid[toolswUid.length - 1]);
          }
          console.log("orderUpdated", this.currentTools);
        })
        .catch(error => {
          console.error("error", error);
          this.processing = false;
          this.$store.dispatch("user/showNotification", {
            title: error.code,
            description: error.message,
            variant: "danger"
          });
        });
    }
  },
  computed: {
    ...mapGetters({
      allTools: "tools/listTools",
      userTools: "user/listTools"
    }),
    filteredTools() {
      if (this.view == "SEARCH") {
        return this.searchedTools;
      }
      return this.allTools.filter(tool => {
        let check = true;
        this.actives.forEach(tag => {
          // return true;
          if (!tool.tags.includes(tag.toLowerCase())) check = false;
        });
        return check;
      });
    },
    searchedTools() {
      if (this.searchStr.trim() == "") return this.allTools;

      return this.allTools.filter(tool => {
        return tool.name
          .toLowerCase()
          .includes(this.searchStr.toLowerCase().trim());
      });
    }
  },
  watch: {
    activeTools(newVal) {
      console.log("activeTools", newVal);
    },
    tools(newVal) {
      console.log("here", newVal);
    }
  }
};
</script>

<style lang="scss" scoped>
.btn.collapsed {
  padding: 11px;
  width: 100%;
  font-style: normal;
  font-weight: bold;
  font-size: 16px;
  line-height: 22px;
  color: #ffffff;
  border-radius: 8px;
  // margin-top: 23px;
}
.ico {
  cursor: pointer;
}
.tools {
  //position: relative;

  .p20 {
    padding: 20px;
  }
  .title {
    font-style: normal;
    font-weight: bold;
    font-size: 16px;
    line-height: 22px;
    color: #474d52;
    margin: 0;
  }
  .icos {
    display: flex;
    .ico:nth-child(2) {
      margin-left: 14px;
    }
  }
  .filter-sec {
    padding-right: 10px;
    padding-left: 20px;
    p {
      font-style: normal;
      font-weight: normal;
      font-size: 14px;
      line-height: 19px;
      color: #474d52;
      margin: 0;
    }
    .filters {
      display: flex;
      align-items: center;
      overflow-x: scroll;
      height: 60px;
      &::-webkit-scrollbar {
        width: 0px;
        background: transparent; /* make scrollbar transparent */
      }
      .filter {
        cursor: pointer;
        font-style: normal;
        font-weight: normal;
        font-size: 14px;
        line-height: 19px;
        color: #474d52;
        background: #ffffff;
        box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.08);
        border-radius: 32px;
        width: 74px;
        // display: flex;
        // justify-content: center;
        // align-items: center;
        height: 35px;
        margin-right: 16px;
        padding: 8px;
        &.active {
          background: rgba(85, 126, 251, 0.1);
          color: var(--theme-color);
        }
      }
    }
  }
  .tools-list {
    padding: 0 8px 24px 24px;
    max-height: 70vh;
    overflow-y: scroll;
    margin-right: 8px;
    &::-webkit-scrollbar {
      height: 0px;
      width: 8px;
      margin-right: 10px;
    }

    &::-webkit-scrollbar-track {
      background-color: #fff;
      // width: 4px;
    }

    &::-webkit-scrollbar-thumb {
      background: #dddddd;
      border-radius: 16px;
      // width: 4px !important;
    }
    .footer {
      position: absolute;
      bottom: 0;
      left: 0;
      width: 100%;
      box-shadow: 0px -4px 12px rgba(0, 0, 0, 0.08);
      display: flex;
      justify-content: center;
      align-items: center;
      .btn-green {
        background-color: #65ea82;
        max-width: 80%;
        margin-top: 12px;
        margin-bottom: 12px;
      }
    }
    .tool {
      position: relative;
      background: #ffffff;
      box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.08);
      border-radius: 8px;
      margin-bottom: 8px;
      &.active {
        background: rgba(85, 126, 251, 0.1);
      }
      .ico {
        position: absolute;
        right: 18px;
        top: 22px;
      }
      .content__tool {
        cursor: pointer;
        padding: 18px;
        .info {
          display: grid;
          grid-template-columns: 32px 1fr;
          grid-column-gap: 14px;
          align-items: center;
          img {
            height: 32px;
            width: 32px;
          }
          h4 {
            margin: 0;
            font-weight: normal;
            font-size: 16px;
            line-height: 22px;
            color: #474d52;
          }
        }
      }
    }
  }
}
.single {
  padding: 24px;
  .header {
    display: grid;
    grid-template-columns: 24px 1fr 24px;
    grid-column-gap: 16px;
  }
  img {
    height: 40px;
    width: 40px;
    margin-top: 32px;
    margin-bottom: 16px;
  }
  .headline {
    font-style: normal;
    font-weight: bold;
    font-size: 20px;
    line-height: 27px;
    margin: 0;
    color: #474d52;
    margin-bottom: 16px;
  }
  .desc {
    font-style: normal;
    font-weight: normal;
    font-size: 16px;
    line-height: 22px;
    color: #474d52;
    margin-top: 24px;
  }
}
.form-control.search {
  border: none;
  &:focus {
    box-shadow: none;
  }
}
.h30 {
  height: 30px;
}
</style>
